/// <reference path="../../../app.definition.ts" />
import angular from 'angular';
export class clientPopupController {

  static $inject = ['$rootScope', '$uibModalInstance', 'data', 'type', 'confirmationMessage', '$timeout'];

  constructor($rootScope, $uibModalInstance, private data, private type, private confirmationMessage, $timeout) {
    var clientPopUpVm: any = this;
    clientPopUpVm.copyTooltipText = "Copy to clipboard";
    clientPopUpVm.copyTooltip = angular.copy(clientPopUpVm.copyTooltipText);
    clientPopUpVm.flag = false;
    clientPopUpVm.showTooltip = true;
    clientPopUpVm.init = () => {
      $rootScope.mainShowLoader = false;
    }

    clientPopUpVm.dismiss = () => {
      clientPopUpVm.flag = false;
      $uibModalInstance.dismiss();
    }

    clientPopUpVm.submit = () => {
      $uibModalInstance.dismiss();
    }

    clientPopUpVm.copySuccessCallback = () => {
      clientPopUpVm.copyTooltip = "successfully copied to clipboard"
      $timeout(() => {
        clientPopUpVm.copyTooltip = angular.copy(clientPopUpVm.copyTooltipText);
      }, 2000)

    }
  }

}

angular.module('eCareVault.common.popUp')
  .controller('clientPopupController', clientPopupController);
